export default __webpack_public_path__ + "static/media/easy.63d0f655.png";